import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import deepmerge from '@mui/utils/deepmerge';
import defaultTranslations from '../translations';
import { jsx as _jsx } from "react/jsx-runtime";
var TranslationsContext = /*#__PURE__*/React.createContext(defaultTranslations);
if (false) TranslationsContext.displayName = "TranslationsContext";
function TranslationsProvider(_ref) {
  var _ref$translations = _ref.translations,
    translations = _ref$translations === void 0 ? {} : _ref$translations,
    children = _ref.children;
  var currentTranslations = React.useContext(TranslationsContext);
  var mergedTranslations = React.useMemo(function () {
    return deepmerge(currentTranslations, translations);
  }, [currentTranslations, translations]);
  return /*#__PURE__*/_jsx(TranslationsContext.Provider, {
    value: mergedTranslations,
    children: children
  });
}
function getPath(obj, path) {
  if (!path || typeof path !== 'string') {
    return null;
  }
  var translation = path.split('.').reduce(function (acc, item) {
    return acc && typeof acc === 'object' && acc[item] || null;
  }, obj);
  if (typeof translation === 'object') {
    return null;
  }
  return translation;
}
var UserLanguageContext = /*#__PURE__*/React.createContext({
  userLanguage: '',
  setUserLanguage: function setUserLanguage() {}
});
if (false) UserLanguageContext.displayName = "UserLanguageContext";
if (false) {
  UserLanguageContext.displayName = 'UserLanguage';
}
export function UserLanguageProvider(props) {
  var children = props.children,
    translations = props.translations,
    defaultUserLanguage = props.defaultUserLanguage;
  var _React$useState = React.useState(defaultUserLanguage),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    userLanguage = _React$useState2[0],
    setUserLanguage = _React$useState2[1];
  var contextValue = React.useMemo(function () {
    return {
      userLanguage: userLanguage,
      setUserLanguage: setUserLanguage
    };
  }, [userLanguage]);
  return /*#__PURE__*/_jsx(TranslationsProvider, {
    translations: translations,
    children: /*#__PURE__*/_jsx(UserLanguageContext.Provider, {
      value: contextValue,
      children: children
    })
  });
}
false ? void 0 : void 0;
export function useUserLanguage() {
  return React.useContext(UserLanguageContext).userLanguage;
}
export function useSetUserLanguage() {
  return React.useContext(UserLanguageContext).setUserLanguage;
}
var warnedOnce = {};

// TODO, migrate to use warnOnce() helper
var warn = function warn(userLanguage, key, ignoreWarning) {
  var fullKey = "".concat(userLanguage, ":").concat(key);
  // No warnings in CI env
  if (!ignoreWarning && !warnedOnce[fullKey] && true) {
    console.warn("Missing translation for ".concat(fullKey));
    warnedOnce[fullKey] = true;
  }
};
export function useTranslate() {
  var userLanguage = useUserLanguage();
  var translations = React.useContext(TranslationsContext);
  return React.useMemo(function () {
    return function translate(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$ignoreWarnin = options.ignoreWarning,
        ignoreWarning = _options$ignoreWarnin === void 0 ? false : _options$ignoreWarnin;
      var wordings = translations[userLanguage];
      if (!wordings) {
        console.error("Missing language: ".concat(userLanguage, "."));
        return '…';
      }
      var translation = getPath(wordings, key);
      if (!translation) {
        warn(userLanguage, key, ignoreWarning);
        var enTranslation = getPath(translations.en, key);
        return enTranslation != null ? enTranslation : null;
      }
      return translation;
    };
  }, [userLanguage, translations]);
}
export function mapTranslations(req) {
  var result = {};
  req.keys().forEach(function (filename) {
    var match = filename.match(/-([a-z]{2}).json$/);
    if (match) {
      result[match[1]] = req(filename);
    } else {
      result.en = req(filename);
    }
  });
  return result;
}